import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, Table, Badge, Spinner, Alert } from 'react-bootstrap';
import { FaCheck, FaTimes, FaEdit, FaBan } from 'react-icons/fa';
import * as FaIcons from 'react-icons/fa';

const AsignacionesTable = ({
    asignaciones,
    loading,
    error,
    total,
    permisosActivos,
    formatearMonto,
    formatearFecha,
    getBadgeVariant,
    getStatusBadgeVariant,
    onAccion,
    onEdit,
    canCreateAsignacion,
    selectedAsignaciones = [],
    onAsignacionSelect,
    onSelectAll
}) => {
    return (
        <Row className="mt-3" style={{ maxHeight: '73%', overflowY: 'auto' }}>
            <Col xs={12}>
                <Card className="shadow-sm border-0">
                    <Card.Header className="bg-light border-0 d-flex align-items-center justify-content-between">
                        <h6 className="mb-0">
                            <FaIcons.FaList className="me-2" style={{ color: '#00b894' }} />
                            Asignaciones ({total})
                        </h6>
                        {loading && <Spinner animation="border" size="sm" variant="primary" />}
                    </Card.Header>
                    <Card.Body className="p-0">
                        {error && (
                            <Alert variant="danger" className="m-3 mb-0">
                                <FaIcons.FaExclamationTriangle className="me-2" />
                                {error}
                            </Alert>
                        )}

                        {!loading && !error && asignaciones.length === 0 && (
                            <div className="text-center p-5">
                                <FaIcons.FaInbox
                                    style={{ fontSize: '3rem', color: '#dee2e6', marginBottom: '16px' }}
                                />
                                <h6 style={{ color: '#6c757d' }}>No hay asignaciones registradas</h6>
                                <p style={{ color: '#6c757d', fontSize: '0.9rem' }}>
                                    {canCreateAsignacion
                                        ? 'Comienza creando una nueva asignación'
                                        : 'No tienes permisos para crear asignaciones'}
                                </p>
                            </div>
                        )}

                        {!loading && !error && asignaciones.length > 0 && (
                            <div className="table-responsive">
                                <Table className="mb-0" hover>
                                    <thead className="table-light">
                                        <tr>
                                            {onAsignacionSelect && (
                                                <th style={{ width: '50px' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedAsignaciones.length === asignaciones.length && asignaciones.length > 0}
                                                        onChange={(e) => onSelectAll(e.target.checked)}
                                                        title="Seleccionar todas"
                                                    />
                                                </th>
                                            )}
                                            <th>Usuario Spread</th>
                                            <th>Sigla Empresa</th>
                                            <th>Ruta</th>
                                            <th>Fecha Ruta</th>
                                            <th>Guía</th>
                                            <th>Extra</th>
                                            <th>Detalle</th>
                                            <th>Tipo Extra</th>
                                            <th>Cantidad</th>
                                            <th>Monto</th>
                                            <th>Total</th>
                                            <th>Fecha Asignación</th>
                                            <th>Creado por</th>
                                            <th>Estado</th>
                                            {(permisosActivos.canApprove && permisosActivos.canAdmin && permisosActivos.canEdit) && (
                                                <th>Acciones</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {asignaciones.map(asignacion => {
                                            const puedeEditar = permisosActivos.canAdmin || permisosActivos.canEdit || permisosActivos.canApprove;
                                            const puedeAccionar = permisosActivos.canApprove && permisosActivos.canAdmin;
                                            
                                            return (
                                                <tr key={asignacion.id}>
                                                    {onAsignacionSelect && (
                                                        <td className="text-center">
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedAsignaciones.includes(asignacion.id)}
                                                                onChange={(e) => onAsignacionSelect(asignacion.id, e.target.checked)}
                                                            />
                                                        </td>
                                                    )}
                                                    <td>
                                                        <strong style={{ color: '#495057' }}>
                                                            {asignacion.usuario_movil?.usuarioSpread || 'N/A'}
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        <Badge bg="info" className="px-2 py-1">
                                                            {asignacion.usuario_movil?.conductor?.empresa?.sigla || 'IND'}
                                                        </Badge>
                                                    </td>
                                                    <td style={{ fontSize: '0.9rem' }}>
                                                        {asignacion.ruta?.ruta || '-'}
                                                    </td>
                                                    <td style={{ fontSize: '0.9rem' }}>
                                                        {asignacion.ruta?.fecha_ruta ? formatearFecha(asignacion?.ruta?.fecha_ruta) : '-'}
                                                    </td>
                                                    <td style={{ fontSize: '0.9rem', color: '#6c757d' }}>
                                                        {asignacion.guia?.guia || '-'}
                                                    </td>
                                                    <td>{asignacion.extra?.extra || 'N/A'}</td>
                                                    <td>
                                                        {asignacion.detalle ? (
                                                            asignacion.detalle.length > 27 ? (
                                                                <span title={asignacion.detalle} style={{ cursor: 'help' }}>
                                                                    {asignacion.detalle.substring(0, 27)}...
                                                                </span>
                                                            ) : (
                                                                asignacion.detalle
                                                            )
                                                        ) : (
                                                            '-'
                                                        )}
                                                    </td>
                                                    <td>
                                                        <Badge
                                                            bg={getBadgeVariant(asignacion.extra?.tipo_extra?.tipo)}
                                                            className="px-2 py-1"
                                                        >
                                                            {asignacion.extra?.tipo_extra?.tipo || 'N/A'}
                                                        </Badge>
                                                    </td>
                                                    <td className="text-center">
                                                        <strong>{asignacion.cantidad || 1}</strong>
                                                    </td>
                                                    <td>
                                                        <strong
                                                            style={{
                                                                color: asignacion.extra?.tipo_extra?.tipo === 'bonos'
                                                                    ? '#28a745'
                                                                    : '#dc3545'
                                                            }}
                                                        >
                                                            {formatearMonto(
                                                                asignacion.monto,
                                                                asignacion.extra?.tipo_extra?.tipo
                                                            )}
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        <strong
                                                            style={{
                                                                color: asignacion.extra?.tipo_extra?.tipo === 'bonos'
                                                                    ? '#28a745'
                                                                    : '#dc3545'
                                                            }}
                                                        >
                                                            {formatearMonto(
                                                                asignacion.monto * (asignacion.cantidad || 1),
                                                                asignacion.extra?.tipo_extra?.tipo
                                                            )}
                                                        </strong>
                                                    </td>
                                                    <td style={{ fontSize: '0.9rem' }}>
                                                        {asignacion.fecha ? formatearFecha(asignacion.fecha) : 'N/A'}
                                                    </td>
                                                    <td>{asignacion.createdBy || 'N/A'}</td>
                                                    <td>
                                                        <Badge
                                                            bg={getStatusBadgeVariant(asignacion.estado?.estado)}
                                                            className="px-2 py-1"
                                                        >
                                                            {asignacion.estado?.estado || 'Sin Estado'}
                                                        </Badge>
                                                        <br />
                                                        {asignacion.estado?.createdBy || 'N/A'}
                                                    </td>
                                                    {puedeAccionar && (
                                                        <td className="text-center" style={{ minWidth: 120 }}>
                                                            {asignacion.estado?.estado === 'creado' && (
                                                                <>
                                                                    <FaCheck
                                                                        title="Aprobar"
                                                                        style={{
                                                                            color: '#28a745',
                                                                            cursor: 'pointer',
                                                                            fontSize: '1.2em',
                                                                            marginRight: 10
                                                                        }}
                                                                        onClick={() => onAccion(asignacion, 'aprobar')}
                                                                    />
                                                                    <FaTimes
                                                                        title="Rechazar"
                                                                        style={{
                                                                            color: '#dc3545',
                                                                            cursor: 'pointer',
                                                                            fontSize: '1.2em',
                                                                            marginRight: 10
                                                                        }}
                                                                        onClick={() => onAccion(asignacion, 'rechazar')}
                                                                    />
                                                                </>
                                                            )}
                                                            {asignacion.estado?.estado === 'aprobado' && (
                                                                <FaBan
                                                                    title="Cancelar asignación"
                                                                    style={{
                                                                        color: '#6c757d',
                                                                        cursor: 'pointer',
                                                                        fontSize: '1.2em',
                                                                        marginRight: 10
                                                                    }}
                                                                    onClick={() => onAccion(asignacion, 'cancelar')}
                                                                />
                                                            )}
                                                            {puedeEditar && (
                                                                <FaEdit
                                                                    title="Editar"
                                                                    style={{
                                                                        color: '#0d6efd',
                                                                        cursor: 'pointer',
                                                                        fontSize: '1.2em'
                                                                    }}
                                                                    onClick={() => onEdit(asignacion)}
                                                                />
                                                            )}
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                        )}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

AsignacionesTable.propTypes = {
    asignaciones: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    total: PropTypes.number.isRequired,
    permisosActivos: PropTypes.object.isRequired,
    formatearMonto: PropTypes.func.isRequired,
    formatearFecha: PropTypes.func.isRequired,
    getBadgeVariant: PropTypes.func.isRequired,
    getStatusBadgeVariant: PropTypes.func.isRequired,
    onAccion: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    canCreateAsignacion: PropTypes.bool.isRequired,
    selectedAsignaciones: PropTypes.array,
    onAsignacionSelect: PropTypes.func,
    onSelectAll: PropTypes.func
};

export default AsignacionesTable;
